function TriggersController(stateService, toasterService, userService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    ctrl.isLocked = selectedWorkspace.deployable;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    ctrl.editMode = false;
    loadTriggers();
    ctrl.modalOptions = {
      name: 'stream collection',
      fields: [
        { name: 'Name', key: 'name', type: 'row' },
        { name: 'Description', key: 'description', type: 'row' },
        { name: 'Streams', key: 'streams', type: 'list', listKey: 'name' }
      ],
      deleteCheck: true,
    };
    ctrl.hasCommit = userService.hasCommitPIS();
    ctrl.hasEdit = userService.hasEditPIS();
  };

  const loadTriggers = () => {
    stateService.getTriggers(ctrl.workspaceId).then(data => {
      ctrl.triggers = data;
      checkIfInUse(ctrl.triggers);
    });
  };

  const checkIfInUse = triggers => {
    triggers.map(trigger => {
      if (trigger.conditions.length > 0) {
        trigger.deletable = false;
      } else {
        trigger.deletable = true;
      }
    });
  };

  ctrl.onToggleEdit = event => {
    ctrl.editMode = event.editMode;
    ctrl.selection = event.item;
  };

  ctrl.onDelete = event => {
    stateService.deleteTrigger(ctrl.workspaceId, event.itemId).then(
      response => {
        loadTriggers();
        toasterService.success('toaster.pis-event', 'toaster.pis-delete-trigger-successful');
      },
      function(e) {
        toasterService.error('toaster.pis-event', 'toaster.pis-delete-trigger-failure');
        console.log(e);
      }
    );
  };

  ctrl.onFormSubmit = event => {
    ctrl.editMode = event.mode;
    loadTriggers();
    ctrl.selection = null;
  };

  ctrl.setEditMode = () => {
    ctrl.editMode = true;
  };

  ctrl.goBackToList = () => {
    ctrl.editMode = false;
    loadTriggers();
    ctrl.selection = null;
  };
}

angular
  .module('pis-tool.module')
  .controller('TriggersController', TriggersController);
